// extracted by mini-css-extract-plugin
export default {"wrapper":"vehicles_wrapper__gG2Hs","noVehicles":"vehicles_noVehicles__yL94J"};